import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ErrorDefinition } from '@models/error-definition';

@Injectable()
export class FieldDefinition {
  public label?: string;
	public placeholder: string;
	public formControl: UntypedFormControl;

	public inputType?: string;
	public inputMask?: string;
	public bemPrefix?: string;
	public hintText?: string;
	public hintTextIsHtml?: boolean;
	public errorTextIsHtml?: boolean;
	public showAsterisk?: boolean;
	public errors?: ErrorDefinition;
	public errorStateMatcher?: ErrorStateMatcher;
}
